// extracted by mini-css-extract-plugin
export default {"summary-container":"SpecialityReportSummary_summary-container__NXiNT","summary-ctas":"SpecialityReportSummary_summary-ctas__Oe1df"};